/**
 * Local image assets.
 *
 * Only assets actually rendered by the app belong here — this module is a
 * barrel, so anything listed gets bundled whether it's used or not.
 * Skill / brand / project imagery is served from Sanity's CDN instead.
 */

import circle from '../assets/circle.svg'
import logo from '../assets/logo.svg'

export default {
  circle,
  logo,
}
